import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  checkboxTitle: {
    defaultMessage: 'I have read and agree to the following terms of service:',
    id: 'VT5rcA',
    description: 'label for the terms and conditions checkbox',
  },
  activate: {
    defaultMessage: 'Activate Carriers',
    id: 'hAn80K',
    description: 'button text in popup, clicking will activate the new carrier services',
  },
  title: {
    defaultMessage: 'New Carriers Now Available',
    id: 'FfvLlD',
    description: 'title in popup, informing user that a new carrier services are now available',
  },
  content: {
    defaultMessage:
      'Good news! You can now access new carrier services in ShipStation. Start exploring great rates and expanded shipping options.',
    id: 'FeI1iF',
    description: 'content in popup, informing user that a new carrier services are now available',
  },
  dismiss: {
    defaultMessage: 'No Thanks',
    id: 'Gz7bAs',
    description: 'button text in popup, clicking will dismiss the popup',
  },
  default: {
    description: 'defaultT&C label',
    defaultMessage: 'Terms and Conditions',
    id: 'TpxYyI',
  },
});
